'use strict';
const applyAttributes = require('./util/apply-attributes'),
	ensureElementIfNeeded = require('./util/ensure-element-if-needed');

module.exports = function applyLinkUrl(decorationsElement, url) {
	const element = ensureElementIfNeeded(decorationsElement, 'a', 'a.mapjs-hyperlink', !!url, {target: '_blank', class: 'mapjs-hyperlink icon-hyperlink', 'decoration-type': 'map-link'});
	if (url) {
		applyAttributes(element, {'href': url});
	}
	return element;
};
